const salesFactorsTooltipMap = {
  "Base Sales": "Your underlying sales trend. Sales that happen regardless of short term Marketing",
  "Price Sales": "Sales attributable to the effects of product pricing",
  "External Factors":
    "Sales that occur due to external events relevant to your business / category",
  "Marketing Factors":
    "Sales that are driven by marketing spend. This is incremental to the base sales.",
};

export const getSalesFactorTooltip = (title: string) => {
  return salesFactorsTooltipMap[title as keyof typeof salesFactorsTooltipMap] || "";
};
